import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/all";
import { Splide } from "@splidejs/splide";
import '@splidejs/splide/css';
import "./style.scss";

gsap.registerPlugin(ScrollTrigger);

//Utils
let screnWidth = window.innerWidth;
window.addEventListener("resize",()=>{
    screnWidth = window.innerWidth;
})

const body = document.querySelector("body");

//burger
const menu = document.getElementById("menu");
const line_1 = document.getElementById("line_1");
const line_2 = document.getElementById("line_2");
const line_3 = document.getElementById("line_3");
let menu_state = false;

//nav
const nav = document.getElementById("nav");
const nav_links = document.querySelectorAll(".navigation>li:not(.lang)");
const logo = document.getElementById("logo");

//Animation welcome
const hgroup = document.querySelector(".section-header>hgroup");
const header_info = document.querySelector(".header-info");

//Arrows
const arrow_up = document.getElementById("arrow-up");
const arrow_down = document.getElementById("arrow-down");

//lang
const lang = document.getElementById("lang");
const lang_list = document.querySelector("#lang>ul");
const lang_lis_li = document.querySelectorAll("#lang>ul>li");
let lang_state = false;

//Text-block
let btn_show_more = document.querySelectorAll(".btn-show-more");

//nbr of lines * font-size * line-height - 1px
const lineClamp_small_smartphone = 1 * 12 + 12 * 1.2 - 1;
const lineClamp_smartphone = 12 * 16 + 12 * 1.2 - 1;
const lineClamp_desktop = 18 * 16 + 18 * 1.2 - 1; 

//Counters
const section_counters = document.getElementById("section-counters");
const counter1 = document.getElementById("counter1");
const counter2 = document.getElementById("counter2");
const counter3 = document.getElementById("counter3");

//Carousel
let images = [];
const galerie_btn = document.getElementById("galerie-btn");
const galerie = document.getElementById("galerie");
const main_carousel_splide_list = document.querySelector("#main-carousel .splide__list");
let galerie_state = false;

const full_carousel_galerie = document.getElementById("full-carousel-galerie");
const full_carousel_splide_list = document.querySelector("#full-carousel .splide__list");
const full_carousel_xMark = document.getElementById("full-carousel-xMark");
const carousel_counter_1 = document.querySelector(".carouselCounter span:nth-child(1)");
const carousel_counter_2 = document.querySelector(".carouselCounter span:nth-child(2)");

//Table
const table_arrows = document.querySelectorAll("table .small-arrow");
const table_cell = document.querySelectorAll("tr:not(.trInfo)");

//Accordeon
const accordeon = document.getElementById("accordeon");
const accordeon_arrow = document.getElementById("accordeon-arrow");

//Contact form
const inputs = document.querySelectorAll(".input");
const textarea = document.querySelector(".contact-form textarea");
const submit_btn = document.getElementById("submit-btn");
const emailChain = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
const textChain = /[^a-zéàèüûúùöôõóòäêâîïëçñA-ZÂÀÁÄÃÜÛÚÙÊËÉÈÔÓÒÖÕîïíì\s']/gmu;
const telChain = /[^0-9]/gm;
const textareaChain = /<script>/gmu;

//Line animation

const title_section_project = document.querySelector("#section-project .section-title"); 
const title_section_galerie = document.querySelector("#section-galerie .section-title"); 
const title_section_list = document.querySelector("#section-list .section-title"); 
const title_section_location = document.querySelector("#section-location .section-title"); 
const title_section_contact = document.querySelector("#section-contact .section-title"); 

//ANIMATION WELCOME

window.addEventListener("load",()=>{
    gsap.to(hgroup,{
        autoAlpha:1,
        y:window.innerWidth>1200?"-10%":0,
        duration:1
    });
    gsap.to(header_info,{
        autoAlpha:1,
        y:window.innerWidth>1200?"-120%":0,
        duration:1,
        delay:0.5
    });
});

//MENU ANIMATION

const closeMenu = ()=>{
    body.style.overflow = "initial";                     
    gsap.to(line_1,{attr:{y1:37.11,y2:37,x1:23,x2:58}}); 
    gsap.to(line_3,{attr:{y1:37.11,y2:37,x1:23,x2:58}}); 
    gsap.to(line_2,{autoAlpha:1});
    gsap.to(line_1,{attr:{y1:25.11,y2:25,x1:23,x2:58},delay:0.4});     
    gsap.to(line_3,{attr:{y1:50.11,y2:50,x1:23,x2:58},delay:0.4});     
    gsap.to(nav,{y:"-100%",autoAlpha:0,duration:1.5});
    menu_state = !menu_state;
    if(lang_state){
        window.innerWidth<1200&&gsap.to(lang_list,{y:"-100%",autoAlpha:0});
        lang_state = false;
    }
};
const openMenu = ()=>{
    gsap.to(line_1,{attr:{y1:37.11,y2:37,x1:23,x2:58}});    
    gsap.to(line_3,{attr:{y1:37.11,y2:37,x1:23,x2:58}}); 
    gsap.to(line_2,{autoAlpha:0});
    gsap.to(line_1,{attr:{y1:50.11,y2:25,x1:26,x2:55},delay:0.4});    
    gsap.to(line_3,{attr:{y1:25.11,y2:50,x1:26,x2:55},delay:0.4});
    gsap.to(nav,{y:0,autoAlpha:1,duration:1});
    menu_state = !menu_state;
    body.style.overflow = "hidden";                     
};

//< 1200px events
if(window.innerWidth<1200){ 
    menu.addEventListener("click",()=>{
        if(!menu_state){
            openMenu()
        }else{
            closeMenu()
        }
    });

    lang.addEventListener("click",(event)=>{
        !lang_state&&gsap
        .to(lang_list,{
            y:0,
            autoAlpha:1
        })
        lang_state = !lang_state
    });

    nav_links.forEach((el)=>{
        el.addEventListener("click",()=>{
            menu_state&&closeMenu()
        })
    });

    logo.addEventListener("click",()=>{
        menu_state&&closeMenu()
    });
}

lang_lis_li.forEach((el)=>{
    el.addEventListener("click",function(){
        event.stopPropagation();
        lang_state = false
        const currentLang = lang.firstElementChild.innerText;
        const new_lang = this.dataset.lang;
        lang.firstElementChild.innerText = new_lang;
        this.innerText = currentLang;
        this.dataset.lang = currentLang;
        window.innerWidth<1200&&gsap.to(lang_list,{y:"-100%",autoAlpha:0});
    },false)
});

arrow_up.addEventListener("click",()=>{
    window.scrollTo(0,0)
});

gsap.to(arrow_down,{
    autoAlpha:0,
    ease:"power1",
    scrollTrigger:{
        trigger:title_section_project,
        start:"top bottom-=100px",
        toggleActions: "play none none reverse"
    }
});

arrow_down.addEventListener("click",()=>{
    window.scrollTo(0,window.innerHeight+10)
});

//SHOW-HIDE TEXT ON TEXT BLOCKS

window.addEventListener("load",()=>{ //Remove show more btn if <p> is equal or less to a given size
    const text_block_list = document.querySelectorAll(".block-text p");
    text_block_list.forEach((el)=>{
        const blockNbr = el.dataset.name
        const currentBtn = document.querySelector(`[data-block = ${blockNbr}]`);

        if(screnWidth<375 && el.getBoundingClientRect().height<lineClamp_small_smartphone)!!currentBtn&&currentBtn.remove();
        if(screnWidth>375 && el.getBoundingClientRect().height<lineClamp_smartphone)!!currentBtn&&currentBtn.remove();
        if(screnWidth>1200 && el.getBoundingClientRect().height<lineClamp_desktop)!!currentBtn&&currentBtn.remove();
    });
});

btn_show_more.forEach((el)=>{ //Open full text on btn show more click
    el.addEventListener("click",function(){
        const blockNbr = this.dataset.block.replace("block","");
        const currentBlock = document.querySelector(`[data-name = block${blockNbr}]`);
        gsap.to(currentBlock,{
            height:"auto",
        });
        gsap.to(currentBlock,{
            delay:0.6,
            overflow:"initial",
        })
        this.style.display = "none";
    })
});

//COUNTING NUMBERS


const intersectCounter = (elementRef)=>{
    const observer = new IntersectionObserver(
        ([entry]) => {
            if(entry.intersectionRect.x>0){
                animateValue(counter1, 0, 3, 1500);
                animateValue(counter2, 0, 42, 1500);
                animateValue(counter3, 0, 78, 1500);              
                observer.disconnect()
            }
        },
        { rootMargin: window.innerWidth>900?"-50%":"-40%" }
        );
        observer.observe(elementRef)
};

intersectCounter(section_counters);

function animateValue(obj, start, end, duration) {
    let startTimestamp = null;
    const step = (timestamp) => {
      if (!startTimestamp) startTimestamp = timestamp;
      const progress = Math.min((timestamp - startTimestamp) / duration, 1);
      obj.innerHTML = Math.floor(progress * (end - start) + start);
      if (progress < 1) {
        window.requestAnimationFrame(step);
      }
    };
    window.requestAnimationFrame(step);
};
  
//GALERIE CAROUSEL

const carousel = new Splide( '#main-carousel' ,{ //Mounted after data's fetch
    type:"loop",
    heightRatio:0.8,
    cover:true,
    mediaQuery:"min",
    pagination:false,
    classes:{
        arrow : "splide__arrow small-arrow",
    },
    breakpoints: {
        900: {
            heightRatio:0.5,
        },
		1200: {
            destroy:true,
            fixedHeight:250,
            cover:true,
		},
  }
});
const carousel_full = new Splide( '#full-carousel' ,{ //Mounted after data's fetch
    type:"loop",
    height:"85vh",
    gap:"0.5rem",
    perPage:1,
    autoHeight:true,
    pagination:false,
    mediaQuery:"min",
    keyboard:"global",
    classes:{
        arrow : "splide__arrow small-arrow",
    },
    breakpoints: {
        900: {
            width:"90%",
        },
		1200: {
            width:"90%",
		},
  }
});

function fetchStateData(){ //Call the JSON file, fetch datas and change the DOM

    let promise = new Promise(function(resolved,rejected){
        let ajax = new XMLHttpRequest()
        let url = "/assets/data/images.json"
        ajax.open("GET",url,true)
        ajax.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
        ajax.onload = function(){
            if(this.status === 200){
                resolved(this.response)
            }else{
                rejected("Datas could not be retrieved")
            }
        }
        ajax.send()
    })

    let timeout = new Promise(function(resolved){
        setTimeout(function(){
            resolved()
        },5000)
    })

    async function ajaxAsync(){
        try {
            let data = await Promise.race([promise,timeout])
            if(data === undefined){
                throw new Error("Please check internet connection")
            }else{
                data = JSON.parse(data)
                try {
                    data.images.forEach(el=>{
                        images.push(el);
                        generateMainCarousel(el);
                        generateFullCarousel(el);
                    });
                    carousel.sync( carousel_full );
                    carousel.mount();
                    carousel_full.mount();
                    carousel_counter_2.innerText = carousel_full.length;
                    carousel_full.on( 'move', () => {
                        carousel_counter_1.innerText = carousel_full.index+1;
                    } );
                    document.querySelectorAll(".main-carousel .splide__slide").forEach(el=>{
                        el.addEventListener("click",()=>{
                            const clickedSlide = parseInt(el.id.replace("main-carousel-slide",""));
                            carousel_full.go(clickedSlide-1);
                            gsap.to(full_carousel_galerie,{
                                autoAlpha:1,
                                zIndex:999
                            });
                            body.style.overflow = "hidden";                     
                        })
                    });
                } catch (error) {
                    throw new Error("Could not fetch datas")
                }
            }
        } catch (error) {
            console.error(error)
        }
    }
    
    ajaxAsync()
};

const generateMainCarousel = (url)=>{//Append slides to carousel before mouting it
    const img = document.createElement("img");
    img.src = `/assets/image/${url}`;
    img.alt = "image";
    const li = document.createElement("li");
    li.classList.add("splide__slide");
    li.appendChild(img);
    main_carousel_splide_list.appendChild(li);
};
const generateFullCarousel = (url)=>{//Append slides to carousel before mouting it
    const img = document.createElement("img");
    img.src = `/assets/image/${url}`;
    img.alt = "image";
    const li = document.createElement("li");
    li.classList.add("splide__slide");
    li.appendChild(img);
    full_carousel_splide_list.appendChild(li);
};

galerie_btn.addEventListener("click",()=>{
    if(!galerie_state){
        gsap.to(galerie,{
            height:"auto",
        });
        galerie_state = !galerie_state;
        galerie_btn.innerText = "Voir moins";
    }else{
        gsap.to(galerie,{
            height:750,
        })
        galerie_state = !galerie_state
        galerie_btn.innerText = "Voir plus";
    }
});

function escapeCarousel(){
    if(event.key!="Escape") return;
    gsap.to(full_carousel_galerie,{
        autoAlpha:0,
        zIndex:-1
    });
    body.style.overflow = "initial";                     
};


full_carousel_xMark.addEventListener("click",()=>{
    gsap.to(full_carousel_galerie,{
        autoAlpha:0,
        zIndex:-1
    });
    body.style.overflow = "initial";                     
});
window.addEventListener("keydown",()=>{escapeCarousel()});
window.addEventListener("load",()=>fetchStateData());

//TABLE

function openRow(el) {
    if(window.innerWidth>1200) return;
    const id = el.dataset.id;
    const row = document.querySelector(`.trInfo[data-id=${id}]`);
    const rowCell = row.firstElementChild;
    const openRow = document.querySelector(`.trInfo.open`);
    const arrow = document.querySelector(`.small-arrow[data-id=${id}]`);

    let openRowCell = null;
    let openId = null;
    let openArrow = null;

    if(!!openRow){
        openId = openRow.dataset.id;
        openArrow = document.querySelector(`.small-arrow[data-id=${openId}]`);
        openRowCell = openRow.firstElementChild;
    }

    const state = row.classList.contains("open");

    if(!state){
        if(!!openRow && !!openArrow){
            //close current opened row
            gsap.to(openRowCell,{
                autoAlpha:0,
                display:"none",
            });
            gsap.to(openRow,{
                height:0,
                delay:0.5
            });
            gsap.to(openArrow,{rotate:0});
            openRow.classList.toggle("open");
            openArrow.classList.toggle("closed");
        }
        //open clicked row
        gsap.to(row,{
            height:300,
        });
        gsap.to(rowCell,{
            delay:0.3,
            display:"table-cell",
            autoAlpha:1,
        });
        gsap.to(arrow,{
            rotate:180,
            backgroundColor:"var(--primary)",
            color:"var(--white)"
        })
        row.classList.toggle("open");
    }else{
        //Close clicked row
        gsap.to(rowCell,{
            autoAlpha:0,
            display:"none",
        });
        gsap.to(row,{
            height:0,
            delay:0.5
        });
        gsap.to(arrow,{
            rotate:0,
            backgroundColor:"var(--white)",
            color:"var(--black)"
        })
        row.classList.toggle("open");
    }

};

table_cell.forEach((el)=>{el.addEventListener("click",()=>openRow(el))});

//ACCORDEON

accordeon.addEventListener("click",function(){
    const state = accordeon_arrow.classList.contains("closed");
    if(state){
        gsap.to(accordeon_arrow,{rotate:180});
        gsap.to(accordeon,{
            height:"auto"
        });
        gsap.to(accordeon,{
            autoAlpha:1,
            delay:0.5
        });
    }else{
        gsap.to(accordeon_arrow,{rotate:0});
        gsap.to(accordeon,{
            overflow:"hidden",
            height:screnWidth<1200?93:136,
        });
    }
    accordeon_arrow.classList.toggle("closed");
});


//CONTACT FORM

inputs.forEach((el)=>{
    moveLabel(el)
    checkInputs(el)
});

function moveLabel(el){
    el.addEventListener("focus",function(){
        const id = el.id;
        const label = document.querySelector(`label[for=${id}]`);
        gsap.to(label,{
            y:"-75%",
            opacity:1
        })
    })
    el.addEventListener("focusout",function(){
        const id = el.id;
        const label = document.querySelector(`label[for=${id}]`);
        if(el.value==="" || el.value===null){
            gsap.to(label,{
                y:0,
                opacity:0.6
            })
        }
    })
};

function checkInputs(el){
    el.addEventListener("input",function(){
        const type = el.type;
        const span = el.nextElementSibling;
        switch (type) {
            case "text":
                if(textChain.test(el.value) || el.value ===""){
                    el.classList.remove("valid");
                    el.style.borderColor = "var(--red)";
                    span.innerText = "Champ non valide";
                }else{
                    el.classList.add("valid");
                    el.style.borderColor = "var(--light-grey)";
                    span.innerText = "";
                }
                break;
                
            case "email":
                    if(emailChain.test(el.value) && el.value !=""){
                        el.classList.add("valid");
                        el.style.borderColor = "var(--light-grey)";
                        span.innerText = "";;
                    }else{
                        el.classList.remove("valid");;
                        el.style.borderColor = "var(--red)";;
                        span.innerText = "Champ non valide";
                    }
                    break;
                    
            case "tel":
                if(telChain.test(el.value)){
                    el.classList.remove("valid");
                    el.style.borderColor = "var(--red)";
                    span.innerText = "Champ non valide";
                }else{
                    el.classList.add("valid");
                    el.style.borderColor = "var(--light-grey)";
                    span.innerText = "";
                }
            break;
                        
            case "textarea":
                if(textareaChain.test(el.value)){
                    el.classList.remove("valid");
                    el.style.borderColor = "var(--red)";
                    span.innerText = "Champ non valide";
                    
                }else{
                    el.classList.add("valid");
                    el.style.borderColor = "var(--light-grey)";
                    span.innerText = "";
                }
            break;
        
            default:
                break;
        }
        const validInput = document.querySelectorAll(".valid").length
        if(validInput===5){
            submit_btn.disabled = false;
        }else{
            submit_btn.disabled = true;
        }
    })
};
moveLabel(textarea);
checkInputs(textarea);

//PROMOTIONS

new Splide( '#promotions-carousel' ,{ 
    type:"loop",
    height:"80vh",
    cover:true,
    mediaQuery:"min",
    autoplay:true,
    interval:3000,
    pauseOnHover:true,
    keyboard:true,
    arrows:false,
    classes:{
        arrow : "splide__arrow small-arrow",
    },
    breakpoints: {
		1200: {
            arrows : true,
		},
  }
}).mount();

//LINE ANIMATION

gsap.to(title_section_project,{
    "--width" : "50%",
    duration:1.5,
    ease:"power1",
    scrollTrigger:{
        trigger:title_section_project,
        start:"top center"
    }
});
gsap.to(title_section_galerie,{
    "--width" : "50%",
    duration:1.5,
    ease:"power1",
    scrollTrigger:{
        trigger:title_section_galerie,
        start:"top center"
    }
});
gsap.to(title_section_list,{
    "--width" : "50%",
    duration:1.5,
    ease:"power1",
    scrollTrigger:{
        trigger:title_section_list,
        start:"top center"
    }
});
gsap.to(title_section_location,{
    "--width" : "50%",
    duration:1.5,
    ease:"power1",
    scrollTrigger:{
        trigger:title_section_location,
        start:"top center"
    }
});
gsap.to(title_section_contact,{
    "--width" : "50%",
    duration:1.5,
    ease:"power1",
    scrollTrigger:{
        trigger:title_section_contact,
        start:"top center"
    }
});